module.exports = __webpack_public_path__ + "static/mission-img-9-bca70875a68c634fd8b2d47415b58615.jpg";